export default __webpack_public_path__ + "static/project-slide-7-2016-765-1291a8e27bc1842910a3a46aaa173a40.jpg";